import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Card } from '@blueprint/card';
import { Text } from '@blueprint/text';

import { ListingCountList } from '../ListingCounts/ListingCounts.styles';
import { ListingImageContainer } from '../ListingImagePreview/ListingImagePreview.styles';

export const CompactListingPreviewCard = styled(Card)(
    ({ theme: { spacing } }) => css`
        display: flex;
        flex-direction: row;
        padding: 0;
        position: relative;

        ${ListingImageContainer} {
            flex: 0 0 7.5em;
            height: 100%;
            min-height: 7.5em;
        }

        ${ListingCountList} {
            margin-bottom: ${spacing['8px']};
        }
    `
);

export const CompactListingDetails = styled('a')(
    ({ theme: { focusRing, spacing } }) => css`
        display: block;
        flex: 1 1 100%;
        padding: ${spacing['8px']};
        text-decoration: none;
        :focus {
            box-shadow: inset ${focusRing};
            outline: 0;
        }
    `
);

export const CompactImageLinkWrapper = styled('a')(
    ({ theme: { focusRing } }) => css`
        position: relative;

        :focus {
            outline: 0;
            :after {
                box-shadow: inset ${focusRing};
                content: '';
                bottom: 0;
                left: 0;
                right: 0;
                top: 0;
                position: absolute;
            }
        }
    `
);

export const CompactListingPrice = styled(Text)(
    ({ theme: { fontSizes, fontWeight, spacing } }) => css`
        font-size: ${fontSizes[8]};
        font-weight: ${fontWeight.bold};
        margin: 0 0 ${spacing['8px']};
        padding-right: ${spacing['64px']};
    `
);

export const CompactListingAddress = styled('address')(
    ({ theme: { colors } }) => css`
        color: ${colors['neutral-6']};
        font-style: normal;
        margin: 0;
    `
);

export const CompactAgentLink = styled('a')(
    ({ theme: { focusRing, spacing } }) => css`
        display: block;
        position: absolute;
        right: ${spacing['8px']};
        top: ${spacing['8px']};

        :focus {
            outline: 0;
            :after {
                box-shadow: inset ${focusRing};
                content: '';
                bottom: 0;
                left: 0;
                right: 0;
                top: 0;
                position: absolute;
            }
        }

        img {
            display: block;
            height: auto;
            width: ${spacing['48px']};
        }
    `
);
